import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { apiGetPatientsPatientIdMedications } from "../../../api";
import { MedicationDto } from "../../../api/api-connector";
import { AppModel } from "../../../app/app-model";
import { Button } from "../../../components/ui-kit/button";
import { useFetch } from "../../../utils/use-fetch";
import { AddMedicationsDialog } from "../medications/add-medications-dialog";
import { MedicationsDataTable } from "../medications/medications-data-table";
import { Patient } from "../patient";

export const VisitMedicationsSection = observer(
  function VisitMedicationsSection(props: {
    app: AppModel;
    patient: Patient;
    onSaved?: () => void | Promise<void>;
  }) {
    const { app, patient, onSaved } = props;
    const [data, setData] = useState<MedicationDto[]>([]);
    const [showAddDialog, setShowAddDialog] = useState(false);

    const { refetch } = useFetch(
      async ({ isRefetch }) => {
        const response = await apiGetPatientsPatientIdMedications({
          path: { patient_id: patient.patientId },
          meta: { useSessionCache: !isRefetch },
        });
        setData(response.data.medications);
      },
      [patient.patientId],
    );

    return (
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-semibold">
            <Trans>Current medications</Trans>
          </span>
          <Button variant="subtle" onClick={() => setShowAddDialog(true)}>
            <Trans>+ Add medication</Trans>
          </Button>
        </div>

        <MedicationsDataTable
          api={patient.api}
          patient={patient}
          data={data}
          disableEdit
          disableHistory
          disablePagination
        />

        {showAddDialog && (
          <AddMedicationsDialog
            app={app}
            onClose={() => setShowAddDialog(false)}
            onSaved={() => {
              void refetch();
              void onSaved?.();
            }}
          />
        )}
      </div>
    );
  },
);
